import React from "react";

const items = [
  "AMERICAN MADE",
  "QUICK TURNAROUND",
  "FREE SHIPPING $100+",
  "CUSTOM APPAREL",
  "PREMIUM DECALS",
  "DTF & HEAT PRESS",
  "AFFORDABLE PRICING",
  "TOP-NOTCH SERVICE",
];

export default function Marquee() {
  const content = [...items, ...items, ...items];
  return (
    <div
      className="bg-[color:var(--primary)] text-white border-y-2 border-black overflow-hidden"
      data-testid="marquee-ribbon"
    >
      <div className="marquee-track py-3">
        {content.map((t, i) => (
          <span
            key={i}
            className="label-mono text-white/95 text-[13px] px-8 inline-flex items-center gap-8"
          >
            {t}
            <span className="inline-block w-2 h-2 bg-white rotate-45" />
          </span>
        ))}
      </div>
    </div>
  );
}
